import { QueryClient } from '@tanstack/react-query';
import produce from 'immer';

import { findStudentIdByUuid } from '~teacher/components/ActivityResult/hooks/useActivityLiveEvent/utils';
import { ActivityResponse } from '~teacher/hook';

export const studentLeaveUpdater = ({ uuid }: { uuid: string }) =>
  produce((activityData: ActivityResponse) => {
    const studentId = findStudentIdByUuid(activityData, uuid);
    if (studentId) {
      activityData.students[studentId].isPresent = false;
    }

    return activityData;
  });

export const studentLeaveCacheUpdater = ({
  queryClient,
  activityInstanceId,
  uuid,
}: {
  queryClient: QueryClient;
  activityInstanceId: number;
  uuid: string;
}) => {
  queryClient.setQueryData(
    ['activity', activityInstanceId],
    studentLeaveUpdater({ uuid })
  );
};
